module.exports = __webpack_public_path__ + "static/media/mastercard.33a39d23.png";